/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloseCaptionsIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Close Captions',
} = {}): string | TemplateResult => {
  return html`<svg
    data-name="ICONS"
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.06248,13.93066c-.80418.00098-1.6118-.22949-2.27-.67383-1.03906-.70215-1.61133-1.85156-1.61133-3.23633,0-1.78027.88916-2.71875,1.63477-3.19336,1.21045-.77051,2.86475-.79395,3.76416-.37402.375.17578.53711.62207.36133.99805-.17529.37402-.62305.53516-.99707.36133-.38916-.18359-1.49951-.24512-2.32324.28027-.62354.39648-.93994,1.04492-.93994,1.92773,0,.88379.3291,1.57227.95117,1.99316.66113.44629,1.60498.54785,2.3501.24609.38281-.15332.8208.03223.97559.41602.15479.38477-.03174.82129-.41602.97656-.46582.1875-.97217.27832-1.47951.27832Z"
      fill="currentColor"
    />
    <path
      d="M7.89355,13.93066c-.8042.00098-1.61182-.22949-2.27002-.6748-1.03906-.70117-1.61133-1.85059-1.61133-3.23535,0-1.78027.88916-2.71875,1.63477-3.19336,1.20947-.77148,2.86377-.79395,3.76465-.37402.375.17578.53711.62207.36133.99805-.17578.37402-.62305.53516-.99707.36133-.39062-.18359-1.49902-.24512-2.32373.28027-.62354.39648-.93994,1.04492-.93994,1.92773,0,.88379.3291,1.57227.95117,1.99316.66211.44629,1.60596.54785,2.35059.24609.38281-.15332.8208.03223.97559.41602.15479.38477-.03174.82129-.41602.97656-.46582.1875-.97217.27832-1.47998.27832Z"
      fill="currentColor"
    />
    <path
      d="M16.75,17H3.25c-1.24072,0-2.25-1.00977-2.25-2.25V5.25c0-1.24023,1.00928-2.25,2.25-2.25h13.5c1.24072,0,2.25,1.00977,2.25,2.25v9.5c0,1.24023-1.00928,2.25-2.25,2.25ZM3.25,4.5c-.41357,0-.75.33691-.75.75v9.5c0,.41309.33643.75.75.75h13.5c.41357,0,.75-.33691.75-.75V5.25c0-.41309-.33643-.75-.75-.75H3.25Z"
      fill="currentColor"
    />
  </svg>`;
};
